import * as React from "react";

function SvgDumbbell(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 368 368"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M344 112h-16c-2.816 0-5.488.576-8 1.472V88c0-13.232-10.768-24-24-24h-16c-13.232 0-24 10.768-24 24v56H112V88c0-13.232-10.768-24-24-24H72c-13.232 0-24 10.768-24 24v25.472c-2.512-.896-5.184-1.472-8-1.472H24c-13.232 0-24 10.768-24 24v96c0 13.232 10.768 24 24 24h16c2.816 0 5.488-.576 8-1.472V280c0 13.232 10.768 24 24 24h16c13.232 0 24-10.768 24-24v-56h144v56c0 13.232 10.768 24 24 24h16c13.232 0 24-10.768 24-24v-25.472c2.512.896 5.184 1.472 8 1.472h16c13.232 0 24-10.768 24-24v-96c0-13.232-10.768-24-24-24zM48 232c0 4.408-3.592 8-8 8H24c-4.408 0-8-3.592-8-8v-96c0-4.408 3.592-8 8-8h16c4.408 0 8 3.592 8 8v96zm48 48c0 4.408-3.592 8-8 8H72c-4.408 0-8-3.592-8-8V88c0-4.408 3.592-8 8-8h16c4.408 0 8 3.592 8 8v192zm160-72H112v-48h144v48zm48-72v144c0 4.408-3.592 8-8 8h-16c-4.408 0-8-3.592-8-8V88c0-4.408 3.592-8 8-8h16c4.408 0 8 3.592 8 8v48zm48 96c0 4.408-3.592 8-8 8h-16c-4.408 0-8-3.592-8-8v-96c0-4.408 3.592-8 8-8h16c4.408 0 8 3.592 8 8v96z" />
    </svg>
  );
}

export default SvgDumbbell;
